module.exports = __webpack_public_path__ + "static/media/email-icon.36d9cad0.svg";